module.exports = __webpack_public_path__ + "static/media/LATMALCOTKITX3.7c2c0b6d.png";